import { Popover, Tag } from "antd";
import { KeyVal } from "../../Layouts";
import { uniq } from "lodash";
import styles from './deviceMap.module.css';
import classnames from 'classnames';
export default function DevicePoint({ device, }: {
    device: DeviceRecord,
}) {
    const [_left, _top] = device?.location.split(',').map(i => Number(i));
    const [left, top] = [`${_left * 100}%`, `${_top * 100}%`];
    return (
        <Popover title='设备信息' content={
            <div>
                <KeyVal name='展位号' value={device?.name} />
                <KeyVal name='设备号' value={device?.device?.deviceSn} />
                <KeyVal name='设备类型' value={device?.device?.type} />
                {
                    !!device?.gatewayMac && <KeyVal name='MAC地址' value={device?.gatewayMac} />
                }
                {
                    device?.device?.isAlarm && !!device?.device?.alarmList?.length ?
                        <KeyVal name='告警类型' value={
                            <div style={{display: 'inline-flex'}}>
                                {
                                    uniq(device?.device?.alarmList || []).map(i => <Tag key={i} color="red">{i}</Tag>)
                                }
                            </div>
                        } />
                        :
                        <KeyVal name='设备状态' value={device?.device?.online ?
                            <span style={{ color: 'green' }}>在线</span>
                            :
                            <span style={{ color: 'grey' }}>离线</span>
                        } />
                }
                <div style={{ marginBottom: 20 }}>
                    {
                        !!device?.isKeepOnline && <Tag>24小时保电</Tag>
                    }
                    {
                        !!device?.isPowerSupply && <Tag>动力电源</Tag>
                    }
                </div>
            </div>
        }>
            <div style={{
                left: left, top: top,
            }} className={classnames({
                [styles['existing-point']]: true,
                [styles['online-point']]: device?.device?.online,
                [styles['offline-point']]: !device?.device?.online,
                [styles['error-point']]: device?.device?.isAlarm && device?.device?.online,
            })}>
                <div className={styles.tags}>
                    {
                        !!device?.isKeepOnline && <div>24H</div>
                    }
                    {
                        !!device?.isPowerSupply && <div>D</div>
                    }
                </div>
            </div>
        </Popover>
    )
}